import { RefObject, useLayoutEffect, useRef, useState } from "react";

const DEFAULT_BOTTOM_PADDING = 24;
const MIN_HEIGHT = 240;

// Measures how much vertical space is left between the top of the element
// this ref is attached to and the bottom of the viewport, so a scrollable
// panel below content of unknown/variable height (breadcrumbs, filters,
// alerts, a findings list...) can still fill "the rest of the screen"
// instead of relying on a fixed px value.
export const useAvailableHeight = <T extends HTMLElement>(
  deps: unknown[] = [],
  bottomPadding: number = DEFAULT_BOTTOM_PADDING
): [RefObject<T>, number | undefined] => {
  const ref = useRef<T>(null);
  const [height, setHeight] = useState<number | undefined>(undefined);

  useLayoutEffect(() => {
    const update = () => {
      if (!ref.current) {
        return;
      }
      const top = ref.current.getBoundingClientRect().top;
      const available = window.innerHeight - top - bottomPadding;
      setHeight(Math.max(available, MIN_HEIGHT));
    };
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return [ref, height];
};
